import { render, staticRenderFns } from "./MobileDemoView.vue?vue&type=template&id=3057af2d&scoped=true&"
import script from "./MobileDemoView.vue?vue&type=script&lang=js&"
export * from "./MobileDemoView.vue?vue&type=script&lang=js&"
import style0 from "./MobileDemoView.vue?vue&type=style&index=0&id=3057af2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057af2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContent,VLayout})
